import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import GameLanding from './components/GameLanding';
import CipherGame from './components/CipherGame';
import CipherTool from './components/CipherTool';
import './App.css';

// Mode constants
const MODES = {
  LANDING: 'landing',
  GAME: 'game',
  TOOL: 'tool'
};

function App() {
  const [mode, setMode] = useState(MODES.LANDING); // Default to Game Mode (landing)

  const handleStartGame = () => {
    setMode(MODES.GAME);
  };

  const handleUseTool = () => {
    setMode(MODES.TOOL);
  };

  return (
    <div className="App">
      <AnimatePresence mode="wait">
        {mode === MODES.LANDING && (
          <GameLanding
            key="landing"
            onStartGame={handleStartGame}
            onUseTool={handleUseTool}
          />
        )}
        {mode === MODES.GAME && (
          <CipherGame
            key="game"
            onBackToUtility={handleUseTool}
          />
        )}
        {mode === MODES.TOOL && (
          <CipherTool
            key="tool"
            onBackToGame={handleStartGame}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
